import moment from 'moment';

const escapeGraphQLString = (value) => String(value).replace(/\\/g, "\\\\").replace(/"/g, '\\"');

const toMomentDate = (dateValue) => {
  if (!dateValue) return null;

  if (moment.isMoment(dateValue)) {
    return dateValue.clone();
  }

  if (dateValue instanceof Date) {
    return moment(dateValue);
  }

  if (typeof dateValue === 'object' && typeof dateValue.toDate === 'function') {
    return moment(dateValue.toDate());
  }

  const parsedDate = moment(dateValue);
  return parsedDate.isValid() ? parsedDate : null;
};

const compactQuery = (query) => query.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export const buildOfcQuotesQuery = ({
  statusFilter = 'tutti',
  dateRange = null,
  useDateRange = false,
  subtotalMin = 0,
  useSubtotalFilter = false,
} = {}) => {
  const whereFilters = [
    `org_pointer: {
      have: {
        objectId: {
          equalTo: "1VtPmaMogI"
        }
      }
    }`,
  ];

  if (statusFilter && statusFilter !== 'tutti') {
    whereFilters.push(`status: { equalTo: "${escapeGraphQLString(statusFilter)}" }`);
  }

  if (useDateRange && dateRange && dateRange.length === 2) {
    const startDate = toMomentDate(dateRange[0])?.startOf('day');
    const endDate = toMomentDate(dateRange[1])?.endOf('day');

    if (startDate?.isValid() && endDate?.isValid()) {
      whereFilters.push(
        `date: {
          greaterThanOrEqualTo: "${startDate.toISOString()}"
          lessThanOrEqualTo: "${endDate.toISOString()}"
        }`
      );
    }
  }

  const subtotalValue = Number(subtotalMin);
  if (useSubtotalFilter && Number.isFinite(subtotalValue)) {
    whereFilters.push(`subtotal: { greaterThanOrEqualTo: ${subtotalValue} }`);
  }

  /**
   * Query to fetch ofc quotes with customer information
   */
  return compactQuery(`
    query FindOfcQuotes {
      ofc_quotes (
        first: 10000,
        where: {
          ${whereFilters.join("\n")}
        }
      ) {
        edges {
          node {
            objectId
            subtotal
            date
            status
            customer_pointer {
              objectId
              nome
              cognome
              partita_iva
              indirizzo
              citta
              cap
              nazionalita
            }
          }
        }
      }
    }
  `);
};

const ofcQuotesQuery = buildOfcQuotesQuery();

export default ofcQuotesQuery;
